import * as React from 'react';

import { useTranslation } from 'react-i18next';

import gtmTracker from '@utils/gtmTracker';

import { useQueryGetMe } from '@hooks/api/user/use-query-me.ts';
import useEnglishTranslation from '@hooks/use-english-translation';

import { config } from '@/config.ts';

import { ActivityHistory } from './components/activity-history';
import { MatchHistory } from './components/match-history';
import { ProfileInfo } from './components/profile-info';
import { PromotionHistory } from './components/promotion-history';
// import { SteamLogin } from './components/steam-login';
import { TradeLink } from './components/trade-link';
import * as Styled from './profile.styled';

enum ActiveHistory {
	PURCHASES = 'purchases',
	PROMOTIONS = 'promotions'
}

const isBlitz = config.BRAND === 'blitz';

type OwnProps = {
	isBuyHistory?: boolean;
};

const Profile: React.FC<OwnProps> = ({ isBuyHistory }) => {
	const { data: userData } = useQueryGetMe();
	const { t } = useTranslation('main');
	const tEn = useEnglishTranslation('main');
	const isPmBrand = config.BRAND === 'pm';

	const [activeTable, setActiveTable] = React.useState<ActiveHistory>(ActiveHistory.PURCHASES);

	const handleActiveTable = (tableType: ActiveHistory) => {
		if (tableType === activeTable) {
			return;
		}
		const label = tableType === ActiveHistory.PURCHASES ? tEn('buy_history') : tEn('promotion_history');
		gtmTracker.trackEvent('click', {
			event_category: 'User_profile',
			event_action: 'Click',
			event_label: label
		});
		setActiveTable(tableType);
	};

	return (
		<Styled.Wrapper>
			{!isBuyHistory && (
				<Styled.Tiles>
					<ProfileInfo />
					{!isBlitz && (
						<>
							<TradeLink />
							{userData?.steam_id && <MatchHistory />}
						</>
					)}
				</Styled.Tiles>
			)}

			<Styled.ButtonRow>
				<Styled.TableSwitchButton
					onClick={() => handleActiveTable(ActiveHistory.PURCHASES)}
					$isActive={activeTable === ActiveHistory.PURCHASES}
					$isNoCursor={isBuyHistory}
					$round={!isPmBrand}
				>
					{t('buy_history')}
				</Styled.TableSwitchButton>
				{!isBlitz && !isBuyHistory && (
					<Styled.TableSwitchButton
						onClick={() => handleActiveTable(ActiveHistory.PROMOTIONS)}
						$isActive={activeTable === ActiveHistory.PROMOTIONS}
					>
						{t('promotion_history')}
					</Styled.TableSwitchButton>
				)}
			</Styled.ButtonRow>
			{activeTable === ActiveHistory.PURCHASES && <ActivityHistory />}
			{activeTable === ActiveHistory.PROMOTIONS && <PromotionHistory />}
		</Styled.Wrapper>
	);
};

export default Profile;
